import { useTrEnumNamespace as e } from "./useTrEnumNamespace.mjs";
//#region src/enums/useTrConversionEvent.ts
var t = () => e("conversionEvent");
//#endregion
export { t as useTrConversionEvent };
